/*
 * @Author: your name
 * @Date: 2020-06-29 10:47:30
 * @LastEditTime: 2020-06-29 11:18:08
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\store\getters.js
 */
const getters = {
    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    token: state => state.user.token,
    partToken: (state) => state.user.partToken,
    avatar: state => state.user.avatar,
    name: state => state.user.name, // state.user.userInfo.enumOrgCategory
    roles: state => state.user.roles,
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
    routes: state => state.permission.routes,
    sideMenuRouters: state => state.permission.sideMenuRouters,
    companyName: state => state.user.companyName,
    userInfo: state => state.user.userInfo,
    companyId: state => state.user.userInfo.orgNodeId,
    EnumOrgCategory: state => state.user.userInfo.enumOrgCategory, // 登陆人角色 1 公司，2 经销商，4供应商，8客户
    addressTree: state => state.commonData.addressTree,
    defaultStockId: state => state.user.userInfo.defaultStockId,
    orgScope: state => state.user.userInfo.orgScope === 1, // 类型：Number  必有字段  备注：数据范围：0或者null：指定(默认) 1：全部
    stockScope: state => state.user.userInfo.stockScope === 1, // 类型：Number  必有字段  备注：仓库范围：0或者null：指定(默认) 1：全部
    auth: state => state.user.permissions, // btn auth
    purchaseForm: state => state.user.purchaseForm // btn auth

}
export default getters
